import { isComplianceOnlyPlan } from '@/lib/billing';

const COMPLIANCE_DEFAULT_PIN_ROLES = new Set([
  'TENANT_ADMIN',
  'COMPLIANCE_OFFICER',
  'QUALITY_OFFICER',
  'COORDINATOR',
]);

/** Build defaults only; persisted pin arrays (including []) replace these wholesale. */
export function defaultSidebarPinsForBillingPlan(
  pins: readonly string[],
  billingPlan?: string | null,
  liveRole?: string | null,
): readonly string[] {
  if (!isComplianceOnlyPlan(billingPlan) || !COMPLIANCE_DEFAULT_PIN_ROLES.has(liveRole ?? ''))
    return pins;
  return [
    ...new Set([
      ...pins,
      '/overview',
      '/compliance/incidents',
      '/compliance/work',
      '/compliance/calendar',
    ]),
  ];
}
